import type { Formato } from "../domain/linhas";

const inteiro = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 0 });
const moedaInteira = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });
const moedaComCentavos = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });
const porcentagem = new Intl.NumberFormat("pt-BR", { style: "percent", maximumFractionDigits: 1 });
const umaCasa = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 1, minimumFractionDigits: 1 });

/** Valor da grade para exibir. Dinheiro chega em centavos. */
export function formatarValor(formato: Formato, valor: number | null): string {
  if (valor === null) return "—";
  switch (formato) {
    case "moeda": {
      const reais = valor / 100;
      // Valor pequeno (CPL, por exemplo) mostra centavos; o resto, inteiro.
      return reais < 100 ? moedaComCentavos.format(reais) : moedaInteira.format(reais);
    }
    case "quantidade":
      return inteiro.format(valor);
    case "porcentagem":
      return porcentagem.format(valor);
    case "multiplicador":
      return `${umaCasa.format(valor)}x`;
  }
}

export const formatarAtingido = (valor: number | null) => (valor === null ? "—" : porcentagem.format(valor));

export const NOME_DO_MES = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
